var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, Fragment, useCallback, useRef, } from 'react';
import merge from 'lodash/merge';
import isEqual from 'lodash/isEqual';
import { Query, Builder, Utils as QbUtils, BasicConfig, } from '@react-awesome-query-builder/ui';
import '@react-awesome-query-builder/ui/css/styles.css';
import './styles.css';
import { Button } from '../Forms/Fields';
import Modal from '../Modal';
import { FilterPopoverContainer, FilterControlsContainer, MarginWrapper, ButtonTextWrapper, ButtonText, } from './styles';
import toast from '../Toast';
var initialValue = {
    id: QbUtils.uuid(),
    type: 'group',
    properties: { conjunction: 'AND' },
};
var types = __assign(__assign({}, BasicConfig.types), { text: merge(BasicConfig.types.text, {
        widgets: {
            field: {
                operators: ['equal', 'not_equal', 'like', 'not_like'],
            },
        },
    }), number: merge(BasicConfig.types.number, {
        widgets: {
            number: {
                operators: __spreadArray(__spreadArray([], BasicConfig.types.number.widgets.number.operators, true), [
                    'remainder',
                ], false),
            },
        },
    }) });
var customOperators = {
    like: {
        label: 'Like',
        labelForFormat: 'Like',
        reversedOp: 'not_like',
        sqlOp: 'LIKE',
        // jsonLogic: (field, op, val) => ({ "in": [val, field] }),
        jsonLogic: 'in',
        _jsonLogicIsRevArgs: true,
        valueSources: ['field', 'value'],
    },
    not_like: {
        label: 'Not like',
        reversedOp: 'like',
        labelForFormat: 'Not Like',
        sqlOp: 'NOT LIKE',
        valueSources: ['field', 'value'],
    },
};
var formattedConfig = __assign(__assign({}, BasicConfig), { operators: __assign(__assign(__assign({}, BasicConfig.operators), customOperators), { remainder: {
            label: 'Remainder (%)',
            labelForFormat: '%',
            sqlOp: '%',
            jsonLogic: '%',
        } }), types: types });
export var LogicalConditions = function (_a) {
    var columns = _a.columns, handleChange = _a.handleChange, value = _a.value, _b = _a.onModalOpenButtonClicked, onModalOpenButtonClicked = _b === void 0 ? function () { return null; } : _b, // Action to perform when the ConditionModal open button is clicked
    _c = _a.selectedTab, // Action to perform when the ConditionModal open button is clicked
    selectedTab = _c === void 0 ? '' : _c, _d = _a.formattedLogicArray, formattedLogicArray = _d === void 0 ? [] : _d;
    var _e = useState(false), showFilterPopover = _e[0], setShowFilterPopover = _e[1];
    var _f = useState(QbUtils.loadTree(initialValue)), query = _f[0], setQuery = _f[1];
    var _g = useState(__assign({}, formattedConfig)), config = _g[0], setConfig = _g[1];
    var prevColumnsRef = useRef();
    useEffect(function () {
        if (!isEqual(prevColumnsRef.current, columns)) {
            prevColumnsRef.current = columns;
            var configuredColumns_1 = {};
            columns === null || columns === void 0 ? void 0 : columns.forEach(function (column) {
                if (column) {
                    configuredColumns_1[column.name] = __assign({}, column);
                }
            });
            setConfig(function (prev) { return (__assign(__assign({}, prev), { fields: configuredColumns_1 })); });
        }
    }, [columns]);
    var loadInitialQuery = useCallback(function () {
        if (Object.keys(value).length !== 0 && value.constructor === Object) {
            setQuery(QbUtils.loadTree(value.query));
        }
        else {
            setQuery(QbUtils.loadTree(initialValue));
        }
    }, [value]);
    useEffect(function () {
        loadInitialQuery();
    }, [loadInitialQuery]);
    var toggleFilterPopover = function () {
        setShowFilterPopover(function (previous) { return !previous; });
    };
    var onQueryChange = function (immutableTree, c) {
        setQuery(immutableTree);
        setConfig(c);
    };
    var renderBuilder = function (props) { return (_jsx("div", __assign({ className: "query-builder-container query-builder", style: { padding: '10px' } }, { children: _jsx("div", { children: _jsx(Builder, __assign({}, props)) }) }))); };
    var saveShowIfEmpty = function () {
        var obj = {};
        var jsonTree = QbUtils.getTree(query);
        obj.query = jsonTree;
        obj.formattedLogic = QbUtils.jsonLogicFormat(query, config).logic;
        if (selectedTab !== '') {
            var containsObject = formattedLogicArray.some(function (item) {
                return selectedTab !== (item === null || item === void 0 ? void 0 : item.key) &&
                    JSON.stringify(item === null || item === void 0 ? void 0 : item.formattedLogic) ===
                        JSON.stringify(obj === null || obj === void 0 ? void 0 : obj.formattedLogic);
            });
        }
        if (selectedTab === '' || !containsObject) {
            handleChange(obj, 'showIfEmpty', 'data');
            toggleFilterPopover();
        }
        else {
            toast.error("Given rule exist for another state of the selected component");
        }
    };
    var clearLogic = function () {
        setQuery(QbUtils.loadTree(initialValue));
    };
    return (_jsxs(FilterPopoverContainer, { children: [_jsx(Modal, __assign({ open: showFilterPopover, size: "large", onClose: function () {
                    loadInitialQuery();
                    toggleFilterPopover();
                } }, { children: _jsxs(Fragment, { children: [_jsx(Query, __assign({}, config, { value: query, onChange: onQueryChange, renderBuilder: renderBuilder, renderSize: "small" })), _jsxs(MarginWrapper, { children: [_jsx(Button, __assign({ small: true, subdued: true, onClick: saveShowIfEmpty }, { children: "Save" })), _jsx(Button, __assign({ small: true, subdued: true, onClick: clearLogic }, { children: "Clear" }))] })] }) })), _jsx(FilterControlsContainer, { children: _jsx(Button, __assign({ small: true, subdued: true, onClick: function () {
                        onModalOpenButtonClicked();
                        toggleFilterPopover();
                    } }, { children: value.formattedLogic === undefined ? (_jsxs(ButtonTextWrapper, { children: [_jsx(ButtonText, { children: "Add" }), _jsx(ButtonText, { children: "Rule" })] })) : (_jsxs(ButtonTextWrapper, { children: [_jsx(ButtonText, { children: "Edit" }), _jsx(ButtonText, { children: "Rule" })] })) })) })] }));
};
export default LogicalConditions;
